export default "/images/vendor/flag-icon-css/flags/4x3/eh.svg?8c8b27438e64065d85428af7cefbba6d";